import { IClassAndSubjectSelected } from '@geneo2-web/shared-ui';
import { QuestionPaperResponse } from '@protos/content_management/cms.content.apis_pb';
import { QuestionPaperType } from '@protos/content_management/content.db_pb';
import { AssessmentTask } from '@protos/learning_management/lms.assessment.common.apis_pb';
import { TeacherLessonInfo } from '@protos/learning_management/lms.lesson.common.apis_pb';
import { BannerV2 } from '@protos/learning_management/lms.teacher.apis_pb';
import { LessonNodeLock } from '@protos/school_management/school.db_pb';
import { TeacherLoginResponseType } from '@protos/user_management/ums.login.apis_pb';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { set } from 'video.js/dist/types/tech/middleware';
// import {} from '@protos/common/'
interface InfoToast {
  label: string | React.ReactElement;
  variant: 'success' | 'error' | 'info';
  open: boolean;
}
interface IQuestionPaperData {
  selected_tab?: QuestionPaperType;
  previous_year_list?: { [pageNumber: number]: QuestionPaperResponse[] };
  sample_paper_list?: { [pageNumber: number]: QuestionPaperResponse[] };
  total_pages?: number;
}
export interface IHomeDashboardState {
  class_subject_info?: IClassAndSubjectSelected | undefined;
  teacher_profile?: unknown;
  // "TeacherLoginResponseType"
  // -> it will contain a "TeachClassSubjects" array which will have class id list and corresponding subjects lists
  school_course_id?: string;
  //selected subject -> it "should be" subject_id from "TeachSubjects" list
  lesson_list?: unknown;
  // LessonInfo[]
  banners?: unknown;
  //Banner[]
  toastInfo: InfoToast;
  toastInfoV2: InfoToast;
  teacher_lesson_list?: TeacherLessonInfo[];
  teacher_hw_list?: AssessmentTask[];
  teacher_banner?: BannerV2[];
  teacher_completed_hw_list?: AssessmentTask[];
  teacher_clicker_hw_list?: AssessmentTask[];
  home_page_lock_status?: LessonNodeLock[];
  teacher_profile_data?: TeacherLoginResponseType;
  question_paper_data?: IQuestionPaperData;
}

const initialState: IHomeDashboardState = {
  class_subject_info: undefined,
  toastInfo: { label: '', variant: 'success', open: false },
  toastInfoV2: { label: '', variant: 'success', open: false },
  question_paper_data: {
    selected_tab: QuestionPaperType.PREVIOUS_YEAR,
    total_pages: 0,
  },
};

export const homeDashboardSlice = createSlice({
  name: 'homeDashboard',
  initialState,
  reducers: {
    //setSchoolCourseId
    setToastInfo: (state, action: PayloadAction<InfoToast>) => {
      state.toastInfo = action.payload;
    },
    setToastInfoV2: (state, action: PayloadAction<InfoToast>) => {
      state.toastInfoV2 = action.payload;
    },
    setClassAndSubjectInfo: (state, action) => {
      state.class_subject_info = action.payload;
    },
    setTeacherLessonList: (state, action) => {
      state.teacher_lesson_list = action.payload;
    },
    setTeacherHwList: (state, action) => {
      state.teacher_hw_list = action.payload;
    },
    setTeacherCompletedHwList: (state, action) => {
      state.teacher_completed_hw_list = action.payload;
    },
    setTeacherClickerAssessmentList: (state, action) => {
      state.teacher_clicker_hw_list = action.payload;
    },
    setTeacherProfileData: (state, action) => {
      state.teacher_profile_data = action.payload;
    },
    setTeacherBanner: (state, action) => {
      state.teacher_banner = action.payload;
    },
    setHomeLockStatus: (state, action) => {
      state.home_page_lock_status = action.payload;
    },
    setQuestionPaperData: (state, action: { payload: IQuestionPaperData }) => {
      state.question_paper_data = action.payload;
    },

    resetHomeDashboardState: (state) => {
      return initialState;
    },
    toggleToastOpen: (state, action) => {
      state.toastInfo.open = action.payload;
    },
    toggleToastOpen2: (state, action) => {
      state.toastInfoV2.open = action.payload;
    },
  },
});

export const {
  setToastInfo,
  setToastInfoV2,
  setClassAndSubjectInfo,
  setTeacherCompletedHwList,
  setTeacherClickerAssessmentList,
  resetHomeDashboardState,
  toggleToastOpen,
  toggleToastOpen2,
  setTeacherLessonList,
  setTeacherHwList,
  setTeacherBanner,
  setHomeLockStatus,
  setTeacherProfileData,
  setQuestionPaperData,
} = homeDashboardSlice.actions;
export default homeDashboardSlice.reducer;
